import { AxiosResponse } from 'axios'
import IBancoResponse from 'modules/pagamentos/domain/entities/IBancoResponse'
import { IBancoRepository } from 'modules/pagamentos/domain/repositories/IBancoRepository'
import { ServiceConfig } from 'shared/services/ServiceConfig'

const http = new ServiceConfig()

export default class BancoRepository implements IBancoRepository {
  public async findAll(): Promise<IBancoResponse[]> {
    const url = '/pagamentos/bancos'
    const response: AxiosResponse<IBancoResponse[]> = await http.get(url)
    return response.data
  }
}
